// List of all Ana-safe hazards which we'd like to load.
// TODO: This should not be needed eventually.

// eslint-disable-next-line no-restricted-imports
import { AnaHazardId } from "@/store/services/facades/types";

export const anaHazards: Record<
  AnaHazardId,
  {
    name: string;
    newId: string;
  }
> = {
  flood_riverine: {
    name: "Riverine Flood",
    newId: "riverineFlood",
  },
  // TODO: Remove? We were getting errors about matching inundation in incorporatedHz, had to change this.
  coastal_inundation: {
    name: "Coastal Inundation",
    newId: "coastalInundation",
  },
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  inundation: {
    name: "Coastal Inundation",
    newId: "coastalInundation",
  },
  cyclone_wind: {
    name: "Tropical Cyclone Wind",
    newId: "cycloneWind",
  },
  heat: {
    name: "Extreme Heat",
    newId: "extremeHeat",
  },
  forest_fire: {
    name: "Forest Fire",
    newId: "forestFire",
  },
  wind: {
    name: "Extreme Wind",
    newId: "extremeWind",
  },
  soil_movement: {
    name: "Soil Movement",
    newId: "soilMovement",
  },
  freeze_thaw: {
    name: "Freeze-Thaw",
    newId: "freezeThaw",
  },
  flood_surfacewater: {
    name: "Surface Water Flood",
    newId: "surfacewaterFlooding",
  },
  landslip: {
    name: "Landslip",
    newId: "landslip",
  },
  landslide: {
    name: "Landslide",
    newId: "landslide",
  },
  cyclone_storm_surge: {
    name: "Tropical Cyclone Storm Surge",
    newId: "tcss",
  },
};
